import { fabric } from "fabric";
import * as fabricJs from "@/mixins/modFabricJsHelper";
import { lightenDarkenColor } from "@/mixins/utils";

function setBackgroundLayer(item, i, canvasMF) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    // INIT BACKGROUND LAYER    
    if (item[i].selected.rulesBackground.type == "none") {
      if (item[i].selected.allowTransparentBack) {
        item[0].canvas.setBackgroundColor(
          {
            source: require("@/assets/transparent-back.png"),
            repeat: "repeat",
          },
          () => {
            item[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja                        
            item[0].canvas.backgroundImage = 0;
            item[0].canvas.transparentBack = true;
            item[0].canvas.requestRenderAll();
            resolve(0);
          }
        );
        setTimeout(() => {
          resolve(0);
        }, 100);
      } else {
        item[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
        item[0].canvas.backgroundImage = 0;
        item[0].canvas.transparentBack = false;
        item[0].canvas.backgroundColor = item[i].selected.transparentBackColor;
        item[0].canvas.requestRenderAll();
        setTimeout(() => {
          resolve(0);
        }, 100);
      }
    } else if (item[i].selected.rulesBackground.type == "color") {
      item[0].canvas.backgroundImage = 0;
      item[0].canvas.transparentBack = false;

      if (item[i].selected.rulesBackground.colorGradient) {
        item[0].canvas.backgroundColor = item[i].selected.rulesBackground.color;
        let transpose =
          "#" +
          lightenDarkenColor(
            item[i].selected.rulesBackground.color.substring(1, 7),
            -40
          ) +
          "FF";
        if (transpose.length <= 7)
          transpose = "#00" + transpose.substring(1, 7);
        //console.log("transpose", transpose);
        item[0].canvas.setBackgroundColor(
          new fabric.Gradient({
            type: "radial",
            coords: {
              r1: 360,
              r2: item[0].canvas.width / 2,
              x1: item[0].canvas.width / 2,
              y1: item[0].canvas.height / 2,
              x2: item[0].canvas.width / 2,
              y2: item[0].canvas.height / 2,
            },
            colorStops: [
              {
                color:
                  "rgba(" +
                  parseInt(
                    item[i].selected.rulesBackground.color.substring(1, 3),
                    16
                  ) +
                  ", " +
                  parseInt(
                    item[i].selected.rulesBackground.color.substring(3, 5),
                    16
                  ) +
                  ", " +
                  parseInt(
                    item[i].selected.rulesBackground.color.substring(5, 7),
                    16
                  ) +
                  ", " +
                  Math.trunc(
                    (parseInt(
                      item[i].selected.rulesBackground.color.substring(7, 9),
                      16
                    ) *
                      100) /
                    255
                  ) /
                  100 +
                  ")",
                offset: 0,
              },
              {
                color:
                  "rgba(" +
                  parseInt(transpose.substring(1, 3), 16) +
                  ", " +
                  parseInt(transpose.substring(3, 5), 16) +
                  ", " +
                  parseInt(transpose.substring(5, 7), 16) +
                  ", " +
                  Math.trunc(
                    (parseInt(transpose.substring(7, 9), 16) * 100) / 255
                  ) /
                  100 +
                  ")",
                offset: 1,
              },
            ],
          })
        );
      } else
        item[0].canvas.backgroundColor = item[i].selected.rulesBackground.color;

      item[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
      item[0].canvas.requestRenderAll();
      setTimeout(() => {
        resolve(0);
      }, 100);
    } else if (item[i].selected.rulesBackground.type == "pattern") {
      item[0].canvas.setBackgroundColor(
        { source: item[i].selected.imageBg, repeat: "repeat", crossOrigin: "*" },
        () => {
          item[0].canvas.backgroundImage = 0;
          item[0].canvas.transparentBack = false;
          item[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
          item[0].canvas.requestRenderAll();
          setTimeout(() => {
            resolve(0);
          }, 100);
        }
      );
    } else if (item[i].selected.rulesBackground.type == "image") {
      fabric.Image.fromURL(
        item[i].selected.imageBg,
        (img) => {
          if (img._element == null) {
            resolve(1);
          }
          img.scaleToWidth(item[i].selected.width * canvasMF);
          img.scaleToHeight(item[i].selected.height * canvasMF);
          item[0].canvas.setBackgroundImage(img);
          item[0].canvas.requestRenderAll();

          item[0].canvas.transparentBack = false;
          item[0].canvas.backgroundColor = "#00000000";
          item[0].canvas.showBackgroundImageControls = true; // skrijemo gumbe za upravljanje ozadja

          // apply saved filter settings
          console.log("F1", item[0].canvas.backgroundImageFilter);
          fabricJs.changeBackgroundImageFilter(item[0], false);
          fabricJs.changeBackgroundImageBrightness(item[0]);
          fabricJs.changeBackgroundImageBlur(item[0]);
          fabricJs.changeBackgroundImageContrast(item[0]);
          setTimeout(() => {
            resolve(0);
          }, 100);
        },
        {
          // Needed to position backgroundImage at 0/0
          originX: "left",
          originY: "top",
          crossOrigin: "*",
        }
      );
    }
  });
}

async function setTemplatePlaceholderImages(item, i, itemPrintItemsTemp, canvasMF, breakpoint) {
  let promises = [];
  // dodamo image placeholderje
  if (itemPrintItemsTemp.length > 0) {
    promises = itemPrintItemsTemp.map((y, index) => {
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        let rect2;

        if (y.clipP == "rect") {
          rect2 = new fabric.Rect({
            fill: "silver",
            left: Number(y.left) * canvasMF,
            top: Number(y.top) * canvasMF,
            width: (Number(y.width) - Number(y.strokeWidth)) * canvasMF,
            height: (Number(y.height) - Number(y.strokeWidth)) * canvasMF,
            lockMovementX: true,
            lockMovementY: true,
            originX: "center",
            originY: "center",
            selectable: false,
            stroke: y.stroke,
            strokeWidth: Number(y.strokeWidth) * canvasMF,
            rx: Number(y.borderRadius) * canvasMF,
            ry: Number(y.borderRadius) * canvasMF,
          });
        } else
          rect2 = new fabric.Ellipse({
            fill: "silver",
            left: Number(y.left) * canvasMF,
            top: Number(y.top) * canvasMF,
            width: Number(y.width) * canvasMF,
            height: Number(y.height) * canvasMF,
            lockMovementX: true,
            lockMovementY: true,
            originX: "center",
            originY: "center",
            selectable: false,
            stroke: y.stroke,
            strokeWidth: Number(y.strokeWidth) * canvasMF,
            rx:
              (Number(y.width) / 2 - Number(y.strokeWidth) / 2) * canvasMF,
            ry:
              (Number(y.height) / 2 - Number(y.strokeWidth) / 2) * canvasMF,
          });

        let group2 = new fabric.Group([rect2], {
          myType: "templatePlaceholder",
          cIndex: 0,
          iIndex: index,
          left: Number(y.left) * canvasMF,
          top: Number(y.top) * canvasMF,
          width: Number(y.width) * canvasMF,
          height: Number(y.height) * canvasMF,
          angle: Number(y.angle),
          lockMovementX: true,
          lockMovementY: true,
          originX: "center",
          originY: "center",
          selectable: true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: item[i].selected.width / 150 * canvasMF,
          rotatingPointOffset: 0,
          cornerSize: breakpoint
            ? item[i].selected.width / 25 * canvasMF
            : item[i].selected.width / 12 * canvasMF,
          cornerShape: "rect",
          transparentCorners: true,
        });

        fabric.Image.fromURL(
          require("@/assets/add-image" + String(index + 1) + ".png"),
          function (img) {
            let img2 = img.set({
              left: Number(y.left) * canvasMF,
              top: Number(y.top) * canvasMF,
              angle: Number(y.angle),
              lockMovementX: true,
              lockMovementY: true,
              originX: "center",
              originY: "center",
              selectable: false,
            });
            img2.scale(0.35 * canvasMF);

            group2.setControlsVisibility({
              tl: false,
              tr: false,
              bl: false,
              br: false,
              ml: false,
              mt: false,
              mr: false,
              mb: false,
              mtr: false,
            });

            /*group2.on("deselected", function () {
              item[0].canvas.showBackgroundImageControls = false;
              console.log("deselected => exitImageEditing/hideControls");
            });*/

            group2.on("selected", function () {
              item[0].canvas.discardActiveObject(); // deselect objetov, da bi potem tap spet prijel
              document
                .getElementById(
                  "canvas-0-input-" + group2.iIndex
                )
                .click();
              console.log("Placeholder selected.");
            });

            group2.addWithUpdate(img2);

            /*if (y.clipP == "circle") {
              group2.clipPath = new fabric.Ellipse({
                fill: "#FF000080", // vseeno
                top: 0,
                left: 0,
                rx: Number(y.width) / 2,
                ry: Number(y.height) / 2,
                angle: Number(y.angle),
                originX: "center",
                originY: "center",
              });
            }*/

            resolve(item[0].canvas.add(group2));
            console.log("TEMPLATE IMAGE ADDED XX", i, index);
          },
          { crossOrigin: "anonymous" }
        );
      });
    });
  }

  await Promise.all(promises).catch((err) => {
    console.log(err);
  });
}

function setMiddleLayer(x, i, canvasMF) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    if (x[i].selected.imageMgURL != "") {
      fabric.Image.fromURL(
        x[i].selected.imageMg,
        (img) => {
          if (img._element == null) {
            resolve(1);
          }
          let img1 = img.set({
            myType: "middleImage",
            selectable: false,
            evented: false,
            originX: "left",
            originY: "top",
            opacity: 1,
          });

          img1.scaleToWidth(x[i].selected.width * canvasMF);
          img1.scaleToHeight(x[i].selected.height * canvasMF);

          x[0].canvas.add(img1).requestRenderAll()
          resolve(0);
        },
        { crossOrigin: "*" }
      );
    } else resolve(0);
  });
}

function setOverlayLayer(item, i, canvasMF) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    // INIT OVERLAY LAYER
    if (item[i].selected.imageFgURL != "") {
      fabric.Image.fromURL(
        item[i].selected.imageFg,
        (img) => {
          if (img._element == null) {
            resolve(1);
          }
          img.scaleToWidth(item[i].selected.width * canvasMF);
          img.scaleToHeight(item[i].selected.height * canvasMF);
          item[0].canvas.setOverlayImage(img);
          item[0].canvas.requestRenderAll();
          resolve(0);
        },
        {
          // Needed to position backgroundImage at 0/0
          originX: "left",
          originY: "top",
          crossOrigin: "*",
        }
      );
    } else resolve(0);
  });
}

export {
  setBackgroundLayer,
  setOverlayLayer,
  setTemplatePlaceholderImages,
  setMiddleLayer
};